import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup } from 'reactstrap';
import LabelWithTooltipComponent from './LabelWithTooltipComponent';

/**
 * InputComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the InputComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders an component field with label and tooltip.
 */
const BaseComponent = ({ children, question }) => {
    return question?.question_label ? (
        <FormGroup>
            <LabelWithTooltipComponent
                name={question?.question_label || ''}
                htmlFor={question?.id || "_temp"}
                target={"label_" + (question?.id)}
                is_active={!!question?.is_active_tooltip}
                tooltip_message={question?.tooltip || ''}
            />

            {children}
            {/* {!!validation?.is_active && validation.touched?.[question?.name] && validation.errors?.[question?.name] &&
                (
                    <FormFeedback type="invalid">
                        {validation.errors?.[question?.name]}
                    </FormFeedback>
                )} */}
        </FormGroup >
    ) : (<FormGroup>{children}</FormGroup>)
}

BaseComponent.propTypes = {
    label: PropTypes.object,
    children: PropTypes.node,
    validation: PropTypes.object,
};

export default BaseComponent;
